export const dark = {
    chart: {
        backgroundColor: "#28292C"
    },
    yAxis: {
        gridLineColor: "#535454",
        labels: {
            style: {
                color: "#A5A6A7"
            }
        }
    },
    xAxis: {
        lineColor: "#535454",
        labels: {
            style: {
                color: "#A5A6A7"
            }
        }
    },
    legend: {
        itemStyle: {
            font: "9pt Open Sans",
            color: "#A5A6A7"
        },
        itemHoverStyle: {
            color: "#F4F4F4"
        }
    }
};

export const light = {
    chart: {
        backgroundColor: "#FFFFFF"
    },
    yAxis: {
        gridLineColor: "#e6e6e6",
        labels: {
            style: {
                color: "#666666"
            }
        }
    },
    xAxis: {
        lineColor: "#e6e6e6",
        labels: {
            style: {
                color: "#666666"
            }
        }
    },
    legend: {
        itemStyle: {
            font: "9pt Open Sans",
            color: "#666666"
        },
        itemHoverStyle: {
            color: "#000000"
        }
    }
};
